import type { StylesConfig } from 'react-select';

// Shared react-select v5 styling used across inline group/layer pickers (EditCard, HeaderDetails).
export function getInlineSelectStyles<Option = any>(): StylesConfig<Option, true>
{
  const isDark = document.documentElement.classList.contains('dark');

  return {
    container: base => ({
      ...base,
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
    }),
    control: base => ({
      ...base,
      border: `1px solid ${isDark ? '#4a4c4c' : '#c4c4c4'}`,
      borderRadius: '3px',
      boxShadow: 'none',
      minHeight: '30px',
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      backgroundColor: isDark ? '#2d2f2f' : '#fff',
      cursor: 'text',
      '&:hover': { border: `1px solid ${isDark ? '#4a4c4c' : '#c4c4c4'}` },
    }),
    valueContainer: base => ({
      ...base,
      padding: '3px 6px',
      flexWrap: 'wrap',
      gap: '3px',
      maxWidth: '100%',
    }),
    multiValue: base => ({
      ...base,
      backgroundColor: isDark ? '#3a3c3c' : '#fff',
      border: `1px solid ${isDark ? '#4a4c4c' : '#c4c4c4'}`,
      borderRadius: '3px',
      margin: '1px',
      fontSize: '11px',
      lineHeight: '1.4',
    }),
    multiValueLabel: base => ({
      ...base,
      color: isDark ? '#e5e0d8' : '#414042',
      padding: '2px 5px',
      fontSize: '11px',
    }),
    multiValueRemove: base => ({
      ...base,
      color: isDark ? '#6e6860' : '#999',
      padding: '0 4px',
      cursor: 'pointer',
      borderLeft: `1px solid ${isDark ? '#4a4c4c' : '#e0e0e0'}`,
      borderRadius: '0 3px 3px 0',
      ':hover': { backgroundColor: '#62accb', color: '#fff' },
    }),
    dropdownIndicator: () => ({ display: 'none' }),
    indicatorSeparator: () => ({ display: 'none' }),
    clearIndicator: () => ({ display: 'none' }),
    placeholder: base => ({ ...base, fontSize: '11px', color: isDark ? '#6e6860' : '#aaa' }),
    input: base => ({ ...base, color: isDark ? '#a9a093' : base.color }),
    menu: base => ({
      ...base,
      zIndex: 99999,
      fontSize: '11px',
      backgroundColor: isDark ? '#333535' : '#fff',
      border: isDark ? '1px solid #4a4c4c' : base.border,
      boxShadow: isDark ? '0 4px 12px rgba(0,0,0,0.4)' : '0 1px 3px rgba(0,0,0,0.2)',
      marginTop: 0,
    }),
    option: (base, state) => ({
      ...base,
      padding: '4px 8px',
      fontSize: '11px',
      backgroundColor: state.isFocused ? '#62accb' : isDark ? '#333535' : 'transparent',
      color: state.isFocused ? '#fff' : isDark ? '#a9a093' : '#333',
      cursor: 'pointer',
    }),
    menuPortal: base => ({ ...base, zIndex: 999999 }),
  };
}
